import React from 'react';
import { Navigate } from 'react-router-dom';

/**
 * Wraps routes that require an authenticated admin user.
 * - Not authenticated → redirect to login.
 * - Authenticated but not admin (e.g. support) → redirect to dashboard.
 * - Authenticated admin → render children.
 */
const AdminRoute = ({ children, isAuthenticated, user }) => {
    if (!isAuthenticated || !user) {
        return <Navigate to="/account/login" replace />;
    }
    if (user?.role !== 'admin') {
        return <Navigate to="/dashboard" replace />;
    }
    return children;
};

export default AdminRoute;
